import React, {FC, PropsWithChildren} from 'react';
import styled from 'styled-components';

import {typographyMixin} from '../typography/typography';
import {redesignedDropdownListPadding} from './dropdownList';

/*
 * Props.
 */

interface DropdownFooterProps {
  className?: string;
}

/*
 * Style.
 */

const StyledFooterDiv = styled.div`
  border-top: 1px solid ${(p) => p.theme.greys.shade30};
  padding: ${(p) => (p.theme.hasDropdownRedesign ? `${redesignedDropdownListPadding}px` : '12px')};

  ${typographyMixin({color: 'tertiary', variant: 'body-small'})}
`;

/*
 * Component.
 */

export const DropdownFooter: FC<PropsWithChildren<DropdownFooterProps>> = ({children, className}) => (
  <StyledFooterDiv className={className}>{children}</StyledFooterDiv>
);
